<template lang="pug">
.view-handbooks.content
  b-navbar.ui-navbar-secondary.is-primary()
    template(#start)
      b-navbar-item(tag="router-link" :to="{name:'cronTasks'}") Задачи
      b-navbar-item(tag="router-link" :to="{name:'cronSettings'}") Настройки
      // b-navbar-item(tag="router-link" :to="{name:'cronStatistics'}") Статистика
  router-view

</template>

<script>
export default {
  name: 'view-handbooks',

  data: () => ({}),
};
</script>
